module.exports = __webpack_public_path__ + "media/images/icons/filled/amazon-square-e1653e5395395a4d3c6e04ee037aaaf0.svg";